import { createElement, Fragment } from "@wordpress/element";
/**
 * Internal dependencies
 */
import { ItemBadgeUI, ItemTitleUI } from '../styles/navigation-styles';
export default function NavigationItemBaseContent(props) {
  const {
    badge,
    title
  } = props;
  return createElement(Fragment, null, title && createElement(ItemTitleUI, {
    className: "components-navigation__item-title",
    as: "span"
  }, title), badge && createElement(ItemBadgeUI, {
    className: "components-navigation__item-badge"
  }, badge));
}
//# sourceMappingURL=base-content.js.map